import axios from "@/api/axios";

const getPages = () => {
    return axios.get(`/pages`);
};

const getPageBySlug = (slug, previewToken) => {
    const params = { pageSlug: slug };
    if (previewToken) {
        params.preview = previewToken;
    }
    return axios.get(`/pages/by-slug`, { params });
}

export default {
    getPages,
    getPageBySlug
};
